import React from 'react';
// Constants
import { CompanyName, SPONSOR_MAIN_URL } from '../../utils/Constants';
// Icons
import { FaQuestion } from 'react-icons/fa';
// Components
import AppAnchor from '../utils/AppAnchor';

function SponsorMiniBanner() {
  return (
    <section className='absolute text-colour1 grid top-4 lg:top-6 right-4 lg:right-8'>
      <article className='grid grid-flow-col gap-4'>
        <div className='hidden md:grid items-center'>
          <AppAnchor
            href={SPONSOR_MAIN_URL}
            ariaLabel={`Explore sponsorship details about ${CompanyName}`}
            titleAttr={`Sponsorship details about ${CompanyName}`}
            target='_blank'
            rel='noopener noreferrer'
            className='bg-colour3 text_shadow font-atop px-6 py-1 rounded-full shadow-cardShadow hover:brightness-90 active:scale-95'
          >
            Sponsored By Yummies
          </AppAnchor>
        </div>
        <div className='grid items-center'>
          <span
            title={`Information about ${CompanyName}`}
            className='bg-colour3 rounded-full p-2 shadow-cardShadow cursor-pointer hover:brightness-125 active:scale-95'
          >
            <FaQuestion />
          </span>
        </div>
      </article>
    </section>
  );
}

export default SponsorMiniBanner;
